import React, { FC, useState, useRef, Fragment } from 'react'
/** @jsx jsx */
import { jsx, css, Global } from '@emotion/core'
import DayPicker from 'react-day-picker'
import { MiniPopup } from '@components/Popup'
import { formatDate } from '@lib/format-date'
import { DatePickerInput } from './DatePickerInput'
// @ts-ignore
import dayPickerStyles from '!!raw-loader!react-day-picker/lib/style.css'
import { customDayPickerStyles } from './common.elements'
import { PopupContent } from './PopupDatePicker.elements'

type Props = {
  date?: Date
  dateFrom?: Date
  dateTo?: Date
  onChange: (date?: Date) => void
  id?: string
  placeholder?: string
  hasError?: boolean
  disabledDays?: { daysOfWeek: number[] }
}

export const PopupDatePicker: FC<Props> = ({
  date,
  dateFrom,
  dateTo,
  onChange,
  id,
  placeholder,
  hasError,
  disabledDays,
}) => {
  const [showPopup, setShowPopup] = useState<boolean>(false)
  const popupRef = useRef<MiniPopup>(null)

  const handlePopupClose = () => setShowPopup(false)
  const handlePopupOpen = () => setShowPopup(true)

  const handleDayChange = (selectedDay: Date, modifiers: Record<string, any> = {}) => {
    if (!modifiers.disabled) {
      onChange(selectedDay)
      handleClose()
    }
  }

  const handleClose = () => {
    const { current } = popupRef
    current && current.close()
  }

  let range: any = {}
  if (dateTo && dateFrom) {
    range.after = dateTo
    range.before = dateFrom
  }
  const modifiers = {
    before: dateTo,
    after: dateFrom,
  }

  return (
    <Fragment>
      <Global styles={css(dayPickerStyles)} />
      <Global styles={css(customDayPickerStyles)} />

      {showPopup && (
        <MiniPopup
          onClose={handlePopupClose}
          maxWidth={545}
          pushDown
          title="Select a month and day:"
          ref={popupRef}
        >
          <PopupContent>
            <DayPicker
              modifiers={modifiers}
              onDayClick={handleDayChange}
              selectedDays={[date]}
              disabledDays={[
                dateFrom && dateTo && range,
                disabledDays
              ]}
              month={new Date()}
            />
          </PopupContent>
        </MiniPopup>
      )}

      <DatePickerInput
        id={`popup-datepicker-${id}`}
        placeholder={placeholder}
        hasError={!!hasError}
        onFocus={handlePopupOpen}
        value={formatDate(date)}
      />
    </Fragment>
  )
}
